import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss']
})
export class DisclaimerComponent extends BaseComponent implements OnInit {

  constructor(private title: Title) {

    super();
    this.title.setTitle('سبدگردان آبان | بیانیه رفع مسئولیت')
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

}
